import {css} from '@emotion/css';
import {useMemo} from 'react';

import {useWolfTheme} from '@br/mg-components';

const useStyles = () => {
    const theme = useWolfTheme();
    return useMemo(
        () => ({
            prompt: css({
                marginBottom: theme.orbitalFour,
            }),
            response: css({
                marginTop: theme.orbitalFour,
            }),
        }),
        [theme.orbitalFour]
    );
};

export default useStyles;
